export { DeleteIcon } from './delete';
